import { render } from "./DischargeProgramModal.vue?vue&type=template&id=3709e56e&ts=true"
import script from "./DischargeProgramModal.vue?vue&type=script&lang=ts"
export * from "./DischargeProgramModal.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__